/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import AudioTrigger from './AudioTrigger';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * Represents a collection of [[AudioTrigger]]s with a set priority.
 */
@cc._decorator.ccclass
export default class AudioCollection extends cc.Component
{
    /** @hidden */
    @property({ type: cc.Integer, visible: true })
    private _priority: number = 0;
    /**
     * The priority to use when two [[AudioCollection]]s conflict. The higher
     * priority takes precedence.
     */
    public get Priority(): number { return this._priority; }

    /** @hidden */
    private _triggers: AudioTrigger[] = [];
    /** The collection of [[AudioTrigger]]s represented by this class. */
    public get Triggers(): AudioTrigger[] { return this._triggers; }

    /** @hidden */
    private _sources: cc.AudioSource[] = [];

    /** @hidden */
    protected onLoad(): void
    {
        this.RegisterTriggers();
        this.RegisterSources();
    }

    /**
     * Regenerates its collection of [[AudioTrigger]]s based on those contained in
     * its child nodes.
     */
    public RegisterTriggers(): void
    {
        this._triggers = this.getComponentsInChildren(AudioTrigger);
    }

    /**
     * Regenerates its collection of [[AudioSource]]s based on those contained in
     * its child nodes.
     */
    public RegisterSources(): void
    {
        this._sources = this.getComponentsInChildren(cc.AudioSource);
    }

    /**
     * Set source volumes to 0.
     */
    public Mute(): void
    {
        this._sources.forEach(source => source.mute = true);
    }

    /**
     * Reset volume for each source to orignal.
     */
    public UnMute(): void
    {
        this._sources.forEach(source => source.mute = false);
    }

    public SetVolume(percent: number): void
    {
        this._triggers.forEach(trigger => trigger.SetVolume(percent));
    }
}
